const NAME = 'ApiError'
const ErrorClass = Error

export default class ApiError extends ErrorClass {
  constructor (message, status = -999, data) {
    super()
    this.name = NAME
    this.status = status
    this.data = data
    //
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor)
    } else {
      this.stack = (new Error(message)).stack
    }
  }

  static isStatusEquals (e, status) {
    if (!ApiError.isInstance(e)) {
      return false
    }
    return e.status === status
  }

  static isInstance (e) {
    return (e.name) && e.name === NAME
  }

  static isAuthError (e) {
    if (!ApiError.isInstance(e)) {
      return false
    }
    return e.status === 401
  }

  static isNotFound (e) {
    if (!ApiError.isInstance(e)) {
      return false
    }
    return e.status === 404
  }

  static isTimeout (e) {
    if (!ApiError.isInstance(e)) {
      return false
    }
    return e.status === -1
  }

  static isNetworkError (e) {
    if (!ApiError.isInstance(e)) {
      return false
    }
    return e.status === -2
  }
}
